/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Status:  * `latest` - Latest FCC version  * `recommended` - Recommended FCC version  * `not_recommended` - Not recommended FCC version  * `unsupported` - Unsupported FCC version 
 */
export enum FccVersionStatusEnumDTO {
    LATEST = 'latest',
    RECOMMENDED = 'recommended',
    NOT_RECOMMENDED = 'not_recommended',
    UNSUPPORTED = 'unsupported'
}

export class ClsFccVersionStatusEnumDTO {
    LATEST = 'latest';
    RECOMMENDED = 'recommended';
    NOT_RECOMMENDED = 'not_recommended';
    UNSUPPORTED = 'unsupported';
}

